import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { CompanyWorkerForms } from '../../../molecules/forms/CompanyWorkerForms';

// Custom components
import { BackdropLoading } from '../../../BackdropLoading';

// Styles
import { Container, Header, Body, Footer, SectionRight, Spacer, } from './styles'
import { FormButton } from '../../../../pages/styles';

// Utils
import { validateForm } from '../../../../utils/commonFunctions';
import { arrayMultipleData } from '../../../../utils/commonFunctions/returnArrayMultiple';
import { PlantApi } from '../../../../services/PlantApi';
import { WorkflowApi } from '../../../../services/WorkflowApi';
import { ConsoleLogger } from '@microsoft/signalr/dist/esm/Utils';

export const CompanyWorkerModalCard = ({ data, dataCertificates, handleSave, handleClose }) => {

    const { t } = useTranslation();
    const plantApi = new PlantApi();
    const workflowApi = new WorkflowApi();


    const [form, setForm] = useState({
        identification: '',
        name: '',
        lastName: '',
        eps: '',
        arl: '',
        //email: '',
        emergencyContactFullName: '',
        emergencyContactPhone: '',
        certificates: dataCertificates,
        //workerRoleId: '',
        //assignations: []
    })
    const [errors, setErrors] = useState({
        identification: { error: '', field: t('worker.table.identification'), required: true },
        //email: { error: '', field: t('worker.table.email'), required: false },
        name: { error: '', field: t('worker.table.name'), required: true },
        lastName: { error: '', field: t('worker.table.lastName'), required: true },
        eps: { error: '', field: t('worker.table.eps'), required: false },
        arl: { error: '', field: t('worker.table.arl'), required: false },
        emergencyContactFullName: { error: '', field: t('worker.table.emergencyContactFullName'), required: false },
        emergencyContactPhone: { error: '', field: t('worker.table.emergencyContactPhone'), required: false },
        //workerRoleId: { error: '', field: t('worker.table.specialty'), required: false },
        //assignations: { error: '', field: t('worker.table.assignations'), required: false }
    })
    const [specialties, setSpecialties] = useState([]);
    const [assignations, setAssignations] = useState([]);
    const [disabled, setDisabled] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        async function call() {
            setLoading(true)
            await getSpecialties();
            const listAssignations = await getAssignations();

            if (data?.workerId) {
                setForm({
                    ...form,
                    id: data.workerId,
                    //email: data.email,
                    identification: data.identification,
                    name: data.name,
                    lastName: data.lastName,
                    eps: data.eps,
                    emergencyContactFullName: data.emergencyContactFullName,
                    emergencyContactPhone: data.emergencyContactPhone,
                    arl: data.arl,
                    //workerRoleId: data.workerRole,
                    companyId: data.companyId,
                    certificates: data?.certificates ?? [],
                    //assignations: data.assignations?.length > 0 ? arrayMultipleData(data.assignations, listAssignations) : []
                })
            }
            setLoading(false)
        }
        call()
    }, [])

    function handleChange(event, name, type) {

        let value = type === "select" ? event : event.target.value;

        //setForm({ ...form, [name]: value })
        setForm(prev => ({ ...prev, [name]: value }));

        if (name === 'email') {
            checkEmailFormat(value);
        } else {
            setErrors(prev => ({
                ...prev,
                [name]: { ...prev[name], error: '' }
            }));
        }

        //setErrors({...errors, [name]: {...errors[name], error: ''}})
    }

    function handleChangeCertificates(id) {
        setForm(prevForm => ({
            ...prevForm,
            certificates: prevForm.certificates.map(cert =>
                cert.id === id ? { ...cert, status: !cert.status } : cert
            )
        }));
    }

    function checkForm() {
        const isEmailValid = checkEmailFormat(form.email);

        let validate = validateForm(form, errors)
        if (validate.hasErrors || !isEmailValid) {
            setErrors(validate.errors)
            return
        }
        handleSave(form)
    }

    async function getSpecialties() {

        const response = await workflowApi.getWorkerSpecialityRoles()

        const data = response.data.map(el => ({
            value: el.id,
            name: el.name
        }))
        setSpecialties(data)

    }

    async function getAssignations() {
        const response = await plantApi.getByUser();
        // Return only the ones that have category "Estación"
        const data = response.data.filter((el) => {
            if (el.category?.id === 1) {
                return true
            }
        });

        setAssignations(data)
        return data
    }

    const checkEmailFormat = (email) => {
        //const email = form.email?.trim();
        const trimmedEmail = email?.trim();

        /*         if (!email) {
                    setErrors(prev => ({
                        ...prev,
                        email: {
                            ...prev.email,
                            error: ''
                        }
                    }));
                    return true;
                } */

        if (!trimmedEmail) {
            setErrors(prev => ({
                ...prev,
                email: {
                    ...prev.email,
                    error: ''
                }
            }));
            return true;
        }

        const isValid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,}$/i.test(email);

        if (!isValid) {
            console.log('Invalid email format:', email);
            setErrors(prev => ({
                ...prev,
                email: {
                    ...prev.email,
                    error: t("system.validations.email")
                }
            }));
            return false;
        }

        // Limpiar error si ya es válido
        setErrors(prev => ({
            ...prev,
            email: {
                ...prev.email,
                error: ''
            }
        }));

        return true;
    };

    return (
        <Container>
            <Header>{data?.id ? t('worker.modal.edit') : t('worker.modal.create')}</Header>
            <Body>
                <CompanyWorkerForms
                    form={form}
                    errors={errors}
                    disabled={disabled}
                    specialties={specialties}
                    assignations={assignations}
                    handleChange={handleChange}
                    handleChangeCertificates={handleChangeCertificates}
                />
            </Body>
            <Footer>
                <SectionRight>
                    <FormButton
                        variant="outlined"
                        type="close"
                        onClick={() => handleClose(false)}
                    >
                        {t('common.cancel')}
                    </FormButton>
                    <Spacer />
                    <FormButton
                        variant="contained"
                        onClick={checkForm}
                    >
                        {t('common.save')}
                    </FormButton>
                </SectionRight>
            </Footer>
            <BackdropLoading open={loading} />
        </Container>
    )
}